// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vt-8";
export var editMode = "_vt-3";
export var headerRow = "_vt-a";
export var headerTitle = "_vt-b";
export var product = "_vt-1";
export var productDetails = "_vt-5";
export var productDivider = "_vt-7";
export var productImage = "_vt-2";
export var productInfo = "_vt-4";
export var productTitle = "_vt-6";
export var strikethrough = "_vt-9";
export var upsellProductsCard = "_vt-0";